import { ColDef, GridOptions, ICellRendererParams } from "ag-grid-community";
import ProgramRenderer from "~/pages/Compliance/CompliancePositionsTable/ProgramRenderer";
import PositionNameRenderer from "./PositionNameRenderer";

export type FatcaPositionRow = {
  positionName: string;
  profileRole: string;
  complianceProgram: string;
  isCurrentCase: boolean;
  positionId?: string;
};

export const defaultColDef: ColDef = {
  sortable: false,
  filter: false,
  resizable: true,
  minWidth: 167,
  cellStyle: { display: "flex", alignItems: "center", textOverflow: "ellipsis" },
};

export const gridOptions: GridOptions = {
  rowHeight: 42,
  headerHeight: 42,
  suppressCellFocus: true,
  suppressRowHoverHighlight: true,
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
  domLayout: "autoHeight",
};

export const crsGridOptions: GridOptions = {
  ...gridOptions,
  rowSelection: "multiple",
  suppressRowClickSelection: true,
};

export const columnDefinition: ColDef<FatcaPositionRow>[] = [
  {
    headerName: "Positions",
    field: "positionName",
    cellRenderer: PositionNameRenderer,
    flex: 1.5,
  },
  {
    headerName: "Profile role",
    field: "profileRole",
    flex: 1,
  },
  {
    headerName: "Compliance program",
    field: "complianceProgram",
    cellRenderer: ProgramRenderer,
    cellRendererParams: (params: ICellRendererParams<FatcaPositionRow>) => ({
      value: [params.data?.complianceProgram].filter(Boolean),
    }),
    flex: 1,
  },
];

export const crsColumnDefinition: ColDef<FatcaPositionRow>[] = [
  {
    headerName: "Position",
    headerCheckboxSelection: true,
    checkboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    field: "positionName",
    cellRenderer: PositionNameRenderer,
    flex: 1.5,
  },
  {
    headerName: "Profile role",
    field: "profileRole",
    flex: 1,
  },
  {
    headerName: "Compliance program",
    field: "complianceProgram",
    cellRenderer: ProgramRenderer,
    cellRendererParams: (params: ICellRendererParams<FatcaPositionRow>) => ({
      value: [params.data?.complianceProgram].filter(Boolean),
    }),
    flex: 1,
  },
];
